import React from 'react'
import { AiFillWindows, AiOutlineCluster } from 'react-icons/ai'
import PropTypes from 'prop-types'
import { FcLinux } from 'react-icons/fc'
import { GLOBALS } from '../../utils/Globals'
import './styles.scss'
import { MdDevices } from "react-icons/md";

export const VirtualMachineType = ({ type, iconSize }) => {
  let Icon
  let name
  
  switch (type) {
    case GLOBALS.virtual_machine.types.W.id:
      Icon = AiFillWindows
      name = GLOBALS.virtual_machine.types.W.name
      break
    case GLOBALS.virtual_machine.types.L.id:
      Icon = FcLinux
      name = GLOBALS.virtual_machine.types.L.name
      break
    case GLOBALS.virtual_machine.types.O.id:
      Icon = MdDevices
      name = GLOBALS.virtual_machine.types.O.name
      break
    case GLOBALS.virtual_machine.types.N.id:
      Icon = AiOutlineCluster
      name = GLOBALS.virtual_machine.types.N.name
      break
    case GLOBALS.virtual_machine.types.T.id:
      Icon = AiOutlineCluster
      name = GLOBALS.virtual_machine.types.T.name
      break
    default:
      Icon = MdDevices
      name = GLOBALS.virtual_machine.types.O.name
      break
  }

  return (
    <div className="type-body">
      <div className="w-icon">
        <Icon size={iconSize} />
      </div>
      <span>{name}</span>
    </div>
  )
}

VirtualMachineType.propTypes = {
  type: PropTypes.string.isRequired,
  iconSize: PropTypes.number,
}
